import { render, staticRenderFns } from "./category-list.vue?vue&type=template&id=c3689dd8&"
import script from "./category-list.vue?vue&type=script&lang=js&"
export * from "./category-list.vue?vue&type=script&lang=js&"
import style0 from "./category-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports